import { createProductsState } from "../types/products-state/products-state.functions";
import { ProductsActions, ProductsActionType } from "./products.actions";
import { ProductsState } from "../types/products-state/products-state.interface";

export function productsReducer(
  state = createProductsState(),
  action: ProductsActionType
): ProductsState {
  switch (action.type) {
    case ProductsActions.Search:
      return {
        ...state,
        loading: true,
      };
    case ProductsActions.SearchSuccess:
      return {
        ...state,
        searchResults: action.payload,
        loading: false,
      };
    case ProductsActions.SearchFailure:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    default:
      return state;
  }
}
